export * from './app-staffsidebar.component';



// WEBPACK FOOTER //
// /var/www/portaldev/bullseye/src/app/components/app-staffsidebar/index.ts